export const SET_AUTH_TOKEN = 'auth/setAuthToken';
export const REMOVE_AUTH_TOKEN = 'auth/removeAuthToken';
